import { getTexts } from "../api/text";
import { setGameTexts } from "../redux/actions";

/**
 * Carga los textos del juego, los guarda en Redux y devuelve una promesa.
 * Así al entrar en la siguiente página ya están en caché y no hay parpadeo.
 */
export function fetchAndStoreGameTexts(dispatch, gameId) {
	if (!gameId) return Promise.resolve();
	return getTexts({ game: gameId })
		.then((res) => {
			if (res?.status === 200 && Array.isArray(res?.data)) {
				const map = res.data.reduce(
					(acc, t) => ({ ...acc, [t.key]: t.value }),
					{}
				);
				dispatch(setGameTexts(gameId, map));
			}
		})
		.catch(() => {});
}
